import React, { useEffect, useState } from "react";
import "../../App.css";
import Swal from "sweetalert2";
import { auth, db } from "../../firebase";
import {
    collection,
    addDoc,
    Timestamp,
    query,
    orderBy,
    onSnapshot,
    deleteDoc,
    doc,
    updateDoc,
} from "firebase/firestore";
import moment from "moment";

export default function AddExpense() {
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
    });

    const [userData, setUserData] = useState(null);
    const [expensehead, setexpensehead] = useState([]);
    const [expenses, setexpenses] = useState([]);

    // Add Form States
    const [headid, setheadid] = useState("");
    const [descreption, setdescreption] = useState("");
    const [amount, setamount] = useState("");
    const [note, setnote] = useState("");
    const [date, setdate] = useState("");

    // Edit States
    const [editId, seteditId] = useState("");
    const [editHead, seteditHead] = useState("");
    const [editdescreption, seteditdescreption] = useState("");
    const [editamount, seteditamount] = useState("");
    const [editNote, seteditNote] = useState("");
    const [editDate, seteditDate] = useState("");

    const [searchText, setsearchText] = useState("");
    const [currentPage, setcurrentPage] = useState(1);
    const itemsPerPage = 10;


    // 🔹 Auth
    useEffect(() => {
        const unsub = auth.onAuthStateChanged((user) => {
            setUserData(user);
        });
        return () => unsub();
    }, []);

    // 🔹 Fetch Expense Heads
    useEffect(() => {
        const q = query(collection(db, "expensehead"), orderBy("staffcat", "asc"));
        const unsub = onSnapshot(q, (querySnapshot) => {
            setexpensehead(
                querySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }))
            );
        });
        return () => unsub();
    }, []);

    // 🔹 Fetch Expenses
    useEffect(() => {
        const q = query(collection(db, "expenses"), orderBy("createdAt", "desc"));
        const unsub = onSnapshot(q, (querySnapshot) => {
            setexpenses(
                querySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }))
            );
        });
        return () => unsub();
    }, []);

    // 🔹 Add Expense
    const handleSubmit = async () => {
        if (!headid || !descreption || !amount) {
            Toast.fire({ icon: "error", title: "Please fill all required fields!" });
            return;
        }

        await addDoc(collection(db, "expenses"), {
            headid,
            descreption,
            amount,
            note,
            date,
            uid: userData?.uid || "",
            createdAt: Timestamp.now(),
        });

        setheadid("");
        setdescreption("");
        setamount("");
        setnote("");
        setdate("");

        Toast.fire({ icon: "success", title: "Expense Added Successfully!" });
    };

    // 🔹 Delete
    const handleDelete = async (id) => {
        await deleteDoc(doc(db, "expenses", id));
        Toast.fire({ icon: "success", title: "Deleted Successfully!" });
    };

    // 🔹 Edit Load
    const handleEdit = (item) => {
        seteditId(item.id);
        seteditHead(item.headid);
        seteditdescreption(item.descreption);
        seteditamount(item.amount);
        seteditNote(item.note);
        seteditDate(item.date);
    };

    // 🔹 Update
    const handleUpdate = async () => {
        await updateDoc(doc(db, "expenses", editId), {
            headid: editHead,
            descreption: editdescreption,
            amount: editamount,
            note: editNote,
            date: editDate,
        });

        Toast.fire({ icon: "success", title: "Updated Successfully!" });
    };

    const filteredExpenses = expenses.filter((item) => {
        const search = searchText.toLowerCase().trim();

        const desc = item.descreption?.toLowerCase() || "";
        const amt = item.amount ? item.amount.toString() : "";

        // 🔥 Get Head Name
        const head = expensehead.find((h) => h.id === item.headid);
        const headName = head?.data.staffcat?.toLowerCase() || "";

        return (
            desc.includes(search) ||
            amt.includes(search) ||
            headName.includes(search)
        );
    });


    // 📄 Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredExpenses.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(filteredExpenses.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setcurrentPage(pageNumber);
    };


    return (
        <div className="content-wrapper">
            <br />
            <section className="content">
                <div className="container-fluid">
                    <button className="btn btn-secondary " style={{ float: "right", textTransform: "uppercase" }} >|| Expense   Mgmt ||</button><br /><br /><br></br>
                    <div className="card p-3 mb-3">
                        <div className="row">
                            <div className="col-sm-2">
                                <label>Expense Head</label>
                                <select
                                    value={headid}
                                    onChange={(e) => setheadid(e.target.value)}
                                    className="form-control"
                                >
                                    <option value="">Select Head</option>
                                    {expensehead.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.data.staffcat}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-sm-3">
                                <label>Descreption</label>
                                <input
                                    type="text"
                                    value={descreption}
                                    onChange={(e) => setdescreption(e.target.value)}
                                    className="form-control"
                                />
                            </div>

                            <div className="col-sm-2">
                                <label>Amount</label>
                                <input
                                    type="text"
                                    value={amount}
                                    onChange={(e) => setamount(e.target.value)}
                                    className="form-control"
                                />
                            </div>

                            <div className="col-sm-2">
                                <label>Date</label>
                                <input
                                    type="date"
                                    value={date}
                                    onChange={(e) => setdate(e.target.value)}
                                    className="form-control"
                                />
                            </div>

                            <div className="col-sm-2 mt-3">
                                <button onClick={handleSubmit} className="btn btn-primary">
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Expense List */}
                    <div className="card shadow-lg border-0">
                        <div className="card-body">

                            {/* 🔎 Search Box */}
                            <div className="row mb-3">
                                <div className="col-md-4">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text bg-primary text-white">
                                                🔍
                                            </span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Search by Name or Amount..."
                                            value={searchText}
                                            onChange={(e) => {
                                                setsearchText(e.target.value);
                                                setcurrentPage(1);
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-hover table-striped">
                                    <thead className="thead-primary">
                                        <tr>
                                            <th>Sr No</th>
                                            <th>Date</th>
                                            <th>Expense Head</th>
                                            <th>Descreption</th>
                                            <th>Amount</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.length > 0 ? (
                                            currentItems.map((item, index) => {
                                                const head = expensehead.find(
                                                    (h) => h.id === item.headid
                                                );

                                                return (
                                                    <tr key={item.id}>
                                                        <td>{indexOfFirstItem + index + 1}</td>
                                                        <td> {moment(item.date).format('DD/MM/YYYY')}</td>
                                                        <td>{head?.data.staffcat || ""}</td>
                                                        <td>{item.descreption}</td>
                                                        <td>{item.amount}</td>
                                                        <td>
                                                            <button
                                                                onClick={() => handleEdit(item)}
                                                                className="btn btn-sm btn-warning mr-2"
                                                                data-toggle="modal"
                                                                data-target="#editModal"
                                                            >
                                                                Edit
                                                            </button>

                                                            <button
                                                                onClick={() => handleDelete(item.id)}
                                                                className="btn btn-sm btn-danger"
                                                            >
                                                                Delete
                                                            </button>

                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="7" className="text-center">
                                                    No Records Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* 📄 Pagination */}
                            {totalPages > 1 && (
                                <nav>
                                    <ul className="pagination justify-content-center mt-3">
                                        {[...Array(totalPages)].map((_, index) => (
                                            <li
                                                key={index}
                                                className={`page-item ${currentPage === index + 1 ? "active" : ""
                                                    }`}
                                            >
                                                <button
                                                    className="page-link"
                                                    onClick={() => handlePageChange(index + 1)}
                                                >
                                                    {index + 1}
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                </nav>
                            )}
                        </div>
                    </div>

                </div>
            </section>

            {/* Edit Modal */}
            <div className="modal fade" id="editModal">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header bg-warning">
                            <h5 className="modal-title">Edit Expense</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span>&times;</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="form-group">
                                <label>Expense Head</label>
                                <select
                                    value={editHead}
                                    onChange={(e) => seteditHead(e.target.value)}
                                    className="form-control"
                                >
                                    <option value="">Select Head</option>
                                    {expensehead.map((item) => (
                                        <option key={item.id} value={item.id}>
                                            {item.data.staffcat}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group">
                                <label>Description</label>
                                <input
                                    type="text"
                                    value={editdescreption}
                                    onChange={(e) => seteditdescreption(e.target.value)}
                                    className="form-control"
                                />
                            </div>

                            <div className="form-group">
                                <label>Amount</label>
                                <input
                                    type="text"
                                    value={editamount}
                                    onChange={(e) => seteditamount(e.target.value)}
                                    className="form-control"
                                />
                            </div>

                            <div className="form-group">
                                <label>Date</label>
                                <input
                                    type="date"
                                    value={editDate}
                                    onChange={(e) => seteditDate(e.target.value)}
                                    className="form-control"
                                />
                            </div>

                            <div className="form-group">
                                <label>Note</label>
                                <input
                                    type="text"
                                    value={editNote}
                                    onChange={(e) => seteditNote(e.target.value)}
                                    className="form-control"
                                />
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={handleUpdate}
                                data-dismiss="modal"
                            >
                                Update
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}
